import React from "react";
import { AppContainer } from "../common/components/AppContainer";
import { RenderApp } from "../common/components/RenderApp";
import { App } from "./App";

RenderApp(
	<AppContainer hideLogoutButton={true}>
		<App />
	</AppContainer>
);
